export const namespaced = true;

export const state = {
  activeRoute: "dashboard",
  pageTitle: ""
};

export const getters = {
  getPageTitle: state => {
    return state.pageTitle;
  }
};

export const mutations = {
  SET_ACTIVE_ROUTE(state, payload) {
    state.activeRoute = payload;
  },
  PAGE_TITLE(state, payload) {
    state.pageTitle = payload;
  }
};
export const actions = {
  setActiveRoute({ commit }, payload) {
    commit("SET_ACTIVE_ROUTE", payload);
  },
  setPageTitle({ commit }, payload) {
    commit("PAGE_TITLE", payload);
  },
  closeApp() {
  }
};
